import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { upsell } from "../HirerBalancePresentation.css.mjs";
const HirerBalanceLayout = ({ upsell: upsell$1 = false, children }) => /* @__PURE__ */ jsx(Box, { className: upsell$1 && upsell, padding: "large", children });
export {
  HirerBalanceLayout
};
